import { useActiveProject } from "@/features/project/ActiveProject";
import { currencyFormatter } from "@/utils/currencyFormatter";
import styled from "@emotion/styled";
import { type Inspiration } from "@repo/api";
import { Icon, Text, imageStrikethroughIcon } from "@repo/skapa";
import { T, getLanguageLocal, t, useTranslation } from "@repo/translation";
import {
  LabelField,
  TwoColumnSectionContainer,
  localizeDateAndTime,
  useSettings,
} from "@repo/ui";

const ImgPlaceholder = styled.div`
  width: 100px;
  display: flex;
  flex-direction: column;
`;

export const InspirationDetails = ({ data }: { data?: Inspiration }) => {
  const { opportunity } = useActiveProject();
  const { dateFnsLocale } = useTranslation();
  const { market, language, general } = useSettings();

  if (!data) {
    return null;
  }

  return (
    <>
      {data.image ? (
        <img src={data.image.url} alt={data.image.alt} />
      ) : (
        <ImgPlaceholder>
          <Icon paths={imageStrikethroughIcon} />
          <Text>
            <T translationKey="prompt.no_image" />
          </Text>
        </ImgPlaceholder>
      )}

      {data.title && (
        <LabelField
          id="name"
          editable={false}
          label={t("label.name")}
          value={data.title}
        />
      )}
      <LabelField
        id="id"
        editable={false}
        label={t("label.id")}
        value={data.id}
      />
      <TwoColumnSectionContainer>
        <LabelField
          id="price"
          editable={false}
          label={t("label.price")}
          value={currencyFormatter({
            value: data?.price?.current,
            currency: data?.currency ?? opportunity?.currency,
            locale: getLanguageLocal(language, market),
            showSign: true,
            disableDecimals: Boolean(general?.localization?.disable_decimals),
            fractions: 2,
          })}
        />
        <LabelField
          id="created"
          editable={false}
          label={t("label.created")}
          value={localizeDateAndTime(data.createdAt ?? "", dateFnsLocale)}
        />
        <LabelField
          id="updated"
          editable={false}
          label={t("label.updated")}
          value={localizeDateAndTime(data.updatedAt ?? "", dateFnsLocale)}
        />
      </TwoColumnSectionContainer>
    </>
  );
};
